import React from 'react';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {MdDelete} from 'react-icons/md';
import Button from "reactstrap/es/Button";
import Row from "reactstrap/es/Row";
import Col from "reactstrap/es/Col";

let commonStrings = new LocalizedStrings(common_strings);

const ClassPlanTableRow = (props) => {

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
    }

    localize();
    return (
        <tr style={{backgroundColor: "white", width: "100%"}}>
            <td>
                <Row>
                    <Col lg="1" style={{
                        display: "flex",
                        alignItems: "center"
                    }}>
                        🔘
                    </Col>
                    <Col lg="11">
                        <div className="align-items-left ml-0 text-default font-weight-400"
                             style={{width: "100%", whiteSpace: "pre-line"}}>
                            {props.item.title}
                        </div>
                    </Col>
                </Row>
            </td>
            <td>
                <div className="text-right align-content-end">
                    <Button size="sm" color="warning" onClick={e => props.deleteClassPlanItem(e, props.item)}>
                        <MdDelete/>
                    </Button>
                </div>
            </td>
        </tr>
    )
};

export default ClassPlanTableRow;